<template>
  <div>
    <a-modal
      v-drag-modal
      wrap-class-name="custom-modal-wrap"
      :bodyStyle="{ padding: '16px', overflow: 'hidden' }"
      v-model="modalVisible"
      :confirmLoading="loading"
      :maskClosable="false"
      @cancel="cancel"
      @ok="confirm"
    >
      <div slot="title">{{ localForm.id ? "编辑" : "新增" }}</div>
      <div style="max-height: 65vh; overflow-y: auto; border: 1px solid #277fd0; overflow-x: hidden; padding: 10px; margin: -10px">
        <a-form-model
          ref="form"
          :model="localForm"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-form-model-item prop="product_id" label="产品名称">
            <a-select
              v-model="localForm.product_id"
              style="width: 100%"
              :show-search="true"
              :filterOption="false"
              @change="onChange"
              @search="handleProductSearch"
              @popupScroll="handleProductPopupScroll"
            >
              <a-select-option
                v-for="val in filteredProductList"
                :key="val.id"
                :value="val.goods ? val.goods.id : val.id"
              >
                {{ val.product_name }}{{ val.goods ? ' (' + val.goods.id + ')' : '' }}
              </a-select-option>
              <a-select-option v-if="isLoadingMoreProducts" disabled key="loading" value="loading">
                <a-spin size="small" /> 加载中...
              </a-select-option>
              <a-select-option v-if="!hasMoreProducts && allLoadedProducts.length > 0" disabled key="no-more" value="no-more">
                已加载全部 {{ filteredProductList.length }} 条数据
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="batch" label="生产日期/批次">
            <a-date-picker v-model="localForm.batch" valueFormat="YYYYMMDD" />
          </a-form-model-item>
          <a-form-model-item prop="number" label="编号">
            <a-select
              mode="tags"
              :value="localForm.number ? [localForm.number] : []"
              :maxTagCount="1"
              placeholder="请输入或选择编号"
              @change="onNumberChange"
            >
              <a-select-option v-for="val in numberOptions" :key="val" :value="val">
                {{ val }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="title" label="原材料描述">
            <a-select mode="tags" v-model="localForm.others.describe_y">
              <a-select-option v-for="(val, index) in titleList" :key="index" :value="val.value">
                {{ val.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="title" label="生产投料描述">
            <a-select mode="tags" v-model="localForm.others.describe_s">
              <a-select-option v-for="(val, index) in titleList1" :key="index" :value="val.value">
                {{ val.label }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <div>
            <a-button type="primary" @click="addNewForm" style="margin-bottom: 20px">
              新增原料信息
            </a-button>
            <div v-for="(mat, index) in localForm.material" :key="'material-' + index">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <span>状态 </span>
                <a-select v-model="mat.state" style="width: 85%">
                  <a-select-option value="正常"> 正常</a-select-option>
                  <a-select-option value="异常"> 异常</a-select-option>
                </a-select>
                <a-button style="margin-left: 10px" size="small" @click="removeFormItem2(index)">
                  <a-icon type="minus" />
                </a-button>
              </div>
              名称
              <a-auto-complete
                v-model="mat.product_name"
                style="width: 85%; margin: 20px 0"
                :dataSource="materialNameOptions"
                placeholder="请选择或输入原料名称"
                :filterOption="filterMaterialOption"
              />
              <br />
              重量
              <a-input v-model="mat.weight" style="width: 66%; margin-right: 2%" @change="onRefresh" />
              <a-select v-model="mat.unit" style="width: 25%" placeholder="单位">
                <a-select-option value="g">g</a-select-option>
                <a-select-option value="kg">kg</a-select-option>
                <a-select-option value="吨">吨</a-select-option>
              </a-select>
              <br />
              批次
              <a-input v-model="mat.material_batch" style="width: 85%; margin: 20px 0" @change="onRefresh" />
              <div style="display: flex; justify-content: left; margin-bottom: 20px;">
                <span style="display: block; width: 18%">检验报告 </span>
                <div style="flex: 1">
                  <Upload :ID_image="mat.report_img" :count="5" @handleChange="(val) => handleChange(val, index)" />
                </div>
              </div>
            </div>
            <div v-for="(item, index) in formList" :key="'formList-' + index">
              <div style="display: flex; align-items: center; justify-content: space-between;">
                <span>状态 </span>
                <a-select v-model="item.state" style="width: 85%">
                  <a-select-option value="正常"> 正常</a-select-option>
                  <a-select-option value="异常"> 异常</a-select-option>
                </a-select>
                <a-button
                  style="margin-left: 10px"
                  size="small"
                  @click="removeFormItem1(index)"
                  v-show="formList.length >= 1"
                >
                  <a-icon type="minus" />
                </a-button>
              </div>
              名称
              <a-auto-complete
                v-model="item.product_name"
                style="width: 85%; margin: 20px 0"
                :dataSource="materialNameOptions"
                placeholder="请选择或输入原料名称"
                :filterOption="filterMaterialOption"
              />
              <br />
              重量
              <a-input v-model="item.weight" style="width: 66%; margin-right: 2%" />
              <a-select v-model="item.unit" style="width: 25%" placeholder="单位">
                <a-select-option value="g">g</a-select-option>
                <a-select-option value="kg">kg</a-select-option>
                <a-select-option value="吨">吨</a-select-option>
              </a-select>
              <br />
              批次
              <a-input v-model="item.material_batch" style="width: 85%; margin: 20px 0" />
              <div style="display: flex; justify-content: left; margin-bottom: 20px;">
                <span style="display: block; width: 18%">检验报告 </span>
                <div style="flex: 1">
                  <Upload :ID_image="item.report_img" :count="5" @handleChange="(val) => handleChange1(val, index)" />
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item prop="start" label="混合起始时间">
            <a-date-picker v-model="localForm.start" show-time placeholder="混合起始时间" />
          </a-form-model-item>
          <a-form-model-item prop="end" label="混合结束时间">
            <a-date-picker v-model="localForm.end" show-time placeholder="混合结束时间" />
          </a-form-model-item>
          <a-form-model-item prop="situation" label="混合均匀情况">
            <a-input v-model="localForm.situation" />
          </a-form-model-item>
          <div>
            <a-button type="primary" @click="addNewForm1" style="margin-bottom: 20px">
              新增抽样产品净含量
            </a-button>
            <div v-for="(wItem, index) in weightList" :key="'weight-' + index">
              抽样产品净含量{{ index + 1 }}
              <a-input v-model="wItem.weight" style="width: 68%; margin-bottom: 20px" />
              <a-button
                style="float: right"
                size="small"
                @click="removeFormItem(index)"
                v-show="weightList.length >= 1"
              >
                <a-icon type="minus" />
              </a-button>
            </div>
          </div>
          <a-form-model-item prop="recorder" label="记录人">
            <a-auto-complete
              v-model="localForm.recorder"
              style="width: 100%"
              placeholder="请选择或输入记录人"
              :dataSource="userNameOptions"
              :filterOption="filterUserOption"
              allowClear
            />
          </a-form-model-item>
          <a-form-model-item prop="reviewer" label="复核人">
            <a-auto-complete
              v-model="localForm.reviewer"
              style="width: 100%"
              placeholder="请选择或输入复核人"
              :dataSource="userNameOptions"
              :filterOption="filterUserOption"
              allowClear
            />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input type="textarea" v-model="localForm.remark" allowClear />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { formulasAdd, formulasEdit } from "@/api/produce";
import { goodsInformationList } from "@/api/goods";
import { fromProductList, tracePici } from "@/api/from";
import { userList } from "@/api/account";
import Upload from '../../../components/Upload/index'

export default {
  name: "FormModal",
  components: { Upload },
  model: { prop: "visible", event: "cancel" },
  props: {
    visible: { type: Boolean, default: false },
    form: { type: Object, default: () => ({}) },
    formList2: { type: Array, default: () => [] },
    clientsClassificationOptions: { type: Array, default: () => [] }
  },
  data() {
    return {
      internalVisible: this.visible,
      localForm: this.buildLocalForm(this.form),
      userList: [],
      titleList: [
        { label: '原料索证齐全', value: '原料索证齐全' },
        { label: '原料验收合格', value: '原料验收合格' }
      ],
      titleList1: [
        { label: '根据订单生产', value: '根据订单生产' }
      ],
      materialArr: [],
      formList: [],
      weightList: [],
      batchList: [],
      rules: {
        product_id: [{ required: true, message: "请选择产品名称", trigger: "change" }],
        batch: [{ required: true, message: "请选择批次", trigger: "change" }],
        number: [{ required: true, message: "请输入编号", trigger: ["change", "blur"] }]
      },
      loading: false,
      allLoadedProducts: [],
      productTotalCount: 0,
      hasMoreProducts: true,
      isLoadingMoreProducts: false,
      productSearchKeyword: '',
      productCurrentPage: 1,
      productPageSize: 50,
      numberOptions: []
    };
  },
  computed: {
    modalVisible: {
      get() { return this.internalVisible; },
      set(val) {
        this.internalVisible = val;
        if (!val) this.$emit("cancel", false);
      }
    },
    filteredProductList() {
      let list = this.allLoadedProducts;
      if (this.productSearchKeyword) {
        const keyword = this.productSearchKeyword.toLowerCase();
        list = list.filter(item => {
          const nameStr = (item.product_name || '').toLowerCase();
          const idStr = String(item.goods?.id || '').toLowerCase();
          return nameStr.includes(keyword) || idStr.includes(keyword);
        });
      }
      return list;
    },
    materialNameOptions() {
      if (!this.localForm.material || this.localForm.material.length === 0) return [];
      return this.localForm.material
        .map(item => item.product_name)
        .filter(name => name && name.trim());
    },
    userNameOptions() {
      return (this.userList || [])
        .map(u => u.name)
        .filter(name => name && name.trim());
    }
  },
  watch: {
    visible(newVal) {
      this.internalVisible = newVal;
    },
    form: {
      handler(newVal) {
        this.localForm = this.buildLocalForm(newVal);
        this.ensureCurrentProductInList();
      },
      deep: true
    },
    "form.net_content": {
      handler(newVal) {
        if (Array.isArray(newVal)) {
          this.weightList = newVal.map(item => ({ weight: item }));
        }
      },
      deep: true
    }
  },
  created() {
    userList({ page_size: 999999 }).then(res => {
      this.userList = res.results || [];
    });
    this.formList = Array.isArray(this.formList2) ? [...this.formList2] : [];
    this.loadMoreProducts(false);
    this.loadNumberHistory();
  },
  methods: {
    buildLocalForm(source) {
      const f = Object.assign({}, source);
      if (f.product_id) f.product_id = Number(f.product_id);
      // 确保 others 存在
      if (!f.others || typeof f.others !== 'object') {
        f.others = { describe_y: [], describe_s: [] };
      } else {
        f.others = Object.assign({ describe_y: [], describe_s: [] }, f.others);
      }
      // 解析 material
      let material = f.material;
      if (typeof material === 'string') {
        try { material = JSON.parse(material); } catch (e) { material = []; }
      }
      if (!Array.isArray(material)) material = [];
      f.material = material.map((node, index) => {
        const n = Object.assign({}, node);
        if (Array.isArray(n.report_img) && n.report_img.length > 0 && typeof n.report_img[0] === 'string') {
          n.report_img = n.report_img.map((url, i) => {
            const parts = url.split("/");
            return { uid: index + '-' + i, name: parts[parts.length - 1], status: "done", url };
          });
        } else if (!Array.isArray(n.report_img)) {
          n.report_img = [];
        }
        return n;
      });
      return f;
    },
    onRefresh() {
      this.$forceUpdate();
    },
    handleChange(fileList, index) {
      this.$set(this.localForm.material[index], "report_img", fileList);
    },
    handleChange1(fileList, index) {
      this.$set(this.formList[index], "report_img", fileList);
    },
    removeFormItem(index) {
      this.weightList.splice(index, 1);
    },
    removeFormItem1(index) {
      this.formList.splice(index, 1);
    },
    removeFormItem2(index) {
      this.localForm.material.splice(index, 1);
      this.$forceUpdate();
    },
    addNewForm() {
      this.formList.push({ state: "正常", product_name: "", weight: "", material_batch: "", report_img: [] });
    },
    addNewForm1() {
      this.weightList.push({ weight: "" });
    },
    loadMoreProducts(isLoadMore = false) {
      if (!isLoadMore) {
        this.productCurrentPage = 1;
        this.allLoadedProducts = [];
      }
      this.isLoadingMoreProducts = true;
      fromProductList({ page: this.productCurrentPage, page_size: this.productPageSize }).then(res => {
        const newList = res.data || [];
        this.productTotalCount = res.count || 0;
        this.allLoadedProducts = isLoadMore
          ? [...this.allLoadedProducts, ...newList]
          : newList;
        this.hasMoreProducts = this.allLoadedProducts.length < this.productTotalCount;
        if (!isLoadMore) {
          this.ensureCurrentProductInList();
        }
      }).finally(() => {
        this.isLoadingMoreProducts = false;
      });
    },
    async ensureCurrentProductInList() {
      const pid = this.localForm && this.localForm.product_id;
      if (!pid) return;
      const hit = this.allLoadedProducts.find(v => (v.goods && v.goods.id == pid) || v.id == pid);
      if (hit) return;
      try {
        const res = await fromProductList({ product_kw: String(pid), page: 1, page_size: 200 });
        const list = (res.data || []).filter(item => (item.goods && item.goods.id == pid) || item.id == pid);
        if (list.length > 0) {
          this.allLoadedProducts = [list[0], ...this.allLoadedProducts];
        }
      } catch (e) {
        console.error('ensureCurrentProductInList 出错:', e);
      }
    },
    handleProductSearch(value) {
      this.productSearchKeyword = value;
    },
    handleProductPopupScroll(e) {
      const { target } = e;
      if (target.scrollHeight - target.scrollTop <= target.clientHeight + 10 && this.hasMoreProducts && !this.isLoadingMoreProducts) {
        this.productCurrentPage++;
        this.loadMoreProducts(true);
      }
    },
    filterMaterialOption(inputValue, option) {
      const text = option && option.componentOptions && option.componentOptions.children
        ? option.componentOptions.children[0].text
        : (typeof option === 'string' ? option : '');
      return text.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
    },
    filterUserOption(inputValue, option) {
      const text = option && option.componentOptions && option.componentOptions.children
        ? option.componentOptions.children[0].text
        : (typeof option === 'string' ? option : '');
      return text.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1;
    },
    onNumberChange(vals) {
      // tags 模式可能多选，业务上编号只保留最后一个，且去除首尾空格
      const raw = Array.isArray(vals) && vals.length > 0 ? vals[vals.length - 1] : '';
      const value = typeof raw === 'string' ? raw.trim() : '';
      this.$set(this.localForm, 'number', value);
    },
    loadNumberHistory() {
      try {
        const raw = localStorage.getItem(this.numberHistoryKey());
        const arr = raw ? JSON.parse(raw) : [];
        this.numberOptions = Array.isArray(arr) ? arr.filter(Boolean) : [];
      } catch (e) {
        this.numberOptions = [];
      }
      if (!this.numberOptions.includes('zcac')) {
        this.numberOptions.unshift('zcac');
      }
    },
    saveNumberHistory(num) {
      if (!num || typeof num !== 'string') return;
      const value = num.trim();
      if (!value) return;
      let list = Array.isArray(this.numberOptions) ? [...this.numberOptions] : [];
      list = list.filter(item => item !== value);
      list.unshift(value);
      if (list.length > 50) list = list.slice(0, 50);
      this.numberOptions = list;
      try {
        localStorage.setItem(this.numberHistoryKey(), JSON.stringify(list));
      } catch (e) {}
    },
    numberHistoryKey() {
      const user = (localStorage.getItem('username') || 'anonymous').trim() || 'anonymous';
      return `formula_number_history:${user}`;
    },
    onChange(val) {
      this.batchList = [];
      this.$delete(this.localForm, 'batch');
      this.materialArr = [];
      this.formList = [];
      this.allLoadedProducts.forEach((item) => {
        if (item.goods && item.goods.id === val) {
          this.materialArr = item.goods.association;
        }
      });
      if (this.materialArr && this.materialArr.length > 0) {
        goodsInformationList({ page: 1, page_size: this.materialArr.length + 10 }).then(res => {
          const goodsMap = {};
          (res.results || []).forEach(node => { goodsMap[String(node.id)] = node.name; });
          const arr = this.materialArr.map(item => ({
            state: '正常',
            product_name: goodsMap[String(item)] || '',
            weight: '',
            material_batch: '',
            report_img: []
          }));
          this.localForm.material = arr;
          if (arr.length === 0 && this.formList.length === 0) {
            this.formList.push({ state: '正常', product_name: '', weight: '', material_batch: '', report_img: [] });
          }
        });
      } else {
        this.localForm.material = [];
        if (this.formList.length === 0) {
          this.formList.push({ state: '正常', product_name: '', weight: '', material_batch: '', report_img: [] });
        }
      }
      this.batchListInfo(val);
    },
    async batchListInfo(id) {
      const res1 = await tracePici({ product_id: id });
      this.batchList = res1.data;
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let material = this.localForm.material;
          if (!Array.isArray(material)) material = [];
          const materialPayload = this.formList.concat(material).map((item) => ({
            ...item,
            report_img: (item.report_img || [])
              .filter((f) => f.status === "done")
              .map((f) => f.url || (f.response && f.response.data && f.response.data.file_url))
              .filter(Boolean)
          }));
          const payload = {
            ...this.localForm,
            material: materialPayload,
            net_content: this.weightList.map(item => item.weight),
            start: this.localForm.start && moment(this.localForm.start).format('YYYY-MM-DD HH:mm:ss').replace(' ', 'T'),
            end: this.localForm.end && moment(this.localForm.end).format('YYYY-MM-DD HH:mm:ss').replace(' ', 'T')
          };
          const func = this.localForm.id ? formulasEdit : formulasAdd;
          func(payload).then((res) => {
            if (res.code !== 200) {
              this.$message.warn(res.message);
            } else {
              this.saveNumberHistory(payload.number);
              this.$message.success(this.localForm.id ? "修改成功" : "新增成功");
              this.$emit(this.localForm.id ? "update" : "create");
              this.cancel();
            }
          }).finally(() => {
            this.loading = false;
          });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      this.formList = [];
      this.weightList = [];
      this.batchList = [];
      this.materialArr = [];
      this.productSearchKeyword = '';
      this.localForm = this.buildLocalForm({ others: {}, material: [] });
      if (this.$refs.form) this.$refs.form.clearValidate();
    }
  }
};
</script>

<style scoped>
</style>
